<ls-breadcrumb currentLocation="LS Accounting"></ls-breadcrumb>
<ls-page>
  <div *ngIf="(lsAccountingLink$ | async) as lsAccountingLink; else loading">
    <div *ngIf="!lsAccountingLink.accountExists; else lsAccountingIframe">
      <div
        i18n="LS Accounting|Description to link LS Accounting @@lsAccountingDescription"
      >
        Your Lightspeed account hasn't been linked yet to Lightspeed accounting.
      </div>
      <div
        i18n="LS Accounting|Description subtext to link LS Accounting @@lsAccountingDescriptionSubtext"
      >
        Please click the button below to link your account.
      </div>
      <div class="u-margin-top-2">
        <ls-button
          buttonText="Link account"
          className="o-button--success"
          (click)="linkAccount(lsAccountingLink.url)"
        ></ls-button>
      </div>
    </div>
    <ng-template #lsAccountingIframe>
      <div class="ls-accounting-wrapper">
        <iframe
          [src]="lsAccountingLink.url"
          frameborder="0"
          class="ls-accounting"
          height="100%"
          width="100%"
        ></iframe>
      </div>
    </ng-template>
  </div>
  <ng-template #loading>
    <ls-spinner-loader isLoading="true"></ls-spinner-loader>
  </ng-template>
</ls-page>
<div
  i18n="LS Accounting|Breadcrumb for LS Accounting @@lsAccountingBreadcrumb"
  id="LS Accounting"
  ls-dynamic-translation
>
  LS Accounting
</div>
<div
  i18n="LS Accounting|Link button to link LS Accounting @@lsAccountingLinkButton"
  id="Link account"
  ls-dynamic-translation
>
  Link account
</div>
